import React, { useEffect, useState } from "react";

const ButtonPreview = ({ button }) => {
  useEffect(() => {});
  const [hover, setHover] = useState(false);
  const toggleHover = () => {
    setHover(!hover);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent:
          button.custom_element_json.style.float == "left"
            ? "flex-start"
            : button.custom_element_json.style.float == "right"
            ? "flex-end"
            : "center",
        position: "relative",
        width: "100%",
      }}
    >
      <button
        onMouseOver={toggleHover}
        onMouseLeave={toggleHover}
        style={
          !hover
            ? {
                justifyContent: "center",
                display: "flex",
                width: button.custom_element_json.style.width,
                position: "relative",
                fontFamily: button.custom_element_json.style.fontFamily,
                fontWeight: button.custom_element_json.style.fontWeight,
                fontSize:
                  button.custom_element_json.style.fontSize > 75
                    ? "75px"
                    : button.custom_element_json.style.fontSize + "px",
                backgroundColor: `rgba(
                ${button.custom_element_json.normalBtn.btnBG.rgb.r},
                ${button.custom_element_json.normalBtn.btnBG.rgb.g},
                ${button.custom_element_json.normalBtn.btnBG.rgb.b},
                ${button.custom_element_json.normalBtn.btnBG.rgb.a}
                )`,
                color: `rgba(
                ${button.custom_element_json.normalBtn.txtColor.rgb.r},
                ${button.custom_element_json.normalBtn.txtColor.rgb.g},
                ${button.custom_element_json.normalBtn.txtColor.rgb.b},
                ${button.custom_element_json.normalBtn.txtColor.rgb.a}
                )`,
                borderColor: `rgba(
               ${button.custom_element_json.normalBtn.btnBorder.rgb.r},
              ${button.custom_element_json.normalBtn.btnBorder.rgb.g},
              ${button.custom_element_json.normalBtn.btnBorder.rgb.b},
              ${button.custom_element_json.normalBtn.btnBorder.rgb.a}`,
                borderStyle: "solid",
                paddingTop:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingTop +
                      button.custom_element_json.style.btnPaddingUnit,
                paddingBottom:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingBottom +
                      button.custom_element_json.style.btnPaddingUnit,
                paddingLeft:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingLeft +
                      button.custom_element_json.style.btnPaddingUnit,
                paddingRight:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingRight +
                      button.custom_element_json.style.btnPaddingUnit,
                borderWidth:
                  button.custom_element_json.style.borderWidth > 25
                    ? 25
                    : button.custom_element_json.style.borderWidth + "px",
                borderRadius:
                  button.custom_element_json.style.borderRadius + "px",
              }
            : {
                display: "flex",
                justifyContent: "center",
                width: button.custom_element_json.style.width,
                position: "relative",
                fontFamily: button.custom_element_json.style.fontFamily,
                fontWeight: button.custom_element_json.style.fontWeight,
                fontSize:
                  button.custom_element_json.style.fontSize > 75
                    ? "75px"
                    : button.custom_element_json.style.fontSize + "px",
                backgroundColor: `rgba(
               ${button.custom_element_json.hoverBtn.btnBg.rgb.r},
               ${button.custom_element_json.hoverBtn.btnBg.rgb.g},
               ${button.custom_element_json.hoverBtn.btnBg.rgb.b},
               ${button.custom_element_json.hoverBtn.btnBg.rgb.a}
               )`,
                color: `rgba(
              ${button.custom_element_json.hoverBtn.txtColor.rgb.r},
              ${button.custom_element_json.hoverBtn.txtColor.rgb.g},
              ${button.custom_element_json.hoverBtn.txtColor.rgb.b},
              ${button.custom_element_json.hoverBtn.txtColor.rgb.a}
              )`,
                borderColor: `rgba(
               ${button.custom_element_json.hoverBtn.btnBorder.rgb.r},
              ${button.custom_element_json.hoverBtn.btnBorder.rgb.g},
              ${button.custom_element_json.hoverBtn.btnBorder.rgb.b},
              ${button.custom_element_json.hoverBtn.btnBorder.rgb.a}`,
                borderRadius:
                  button.custom_element_json.style.borderRadius + "px",
                borderStyle: "solid",
                borderWidth:
                  button.custom_element_json.style.borderWidth > 25
                    ? 25
                    : button.custom_element_json.style.borderWidth + "px",
                paddingTop:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingTop +
                      button.custom_element_json.style.btnPaddingUnit,
                paddingBottom:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingBottom +
                      button.custom_element_json.style.btnPaddingUnit,
                paddingLeft:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingLeft +
                      button.custom_element_json.style.btnPaddingUnit,
                paddingRight:
                  button.custom_element_json.style.paddingTop > 75
                    ? 75
                    : button.custom_element_json.style.paddingRight +
                      button.custom_element_json.style.btnPaddingUnit,
              }
        }
      >
        {button.custom_element_json.content
          ? button.custom_element_json.content
          : "Unnamed"}
      </button>
    </div>
  );
};

export default ButtonPreview;
